import React, { useContext, useEffect, useState } from 'react';
import {db} from '../../firebase/config'
import Heart from '../../assets/Heart';
import './Post.css';
import { getDocs,collection } from 'firebase/firestore';
import { PostContext } from '../../store/PostContext';
import { useNavigate } from 'react-router-dom';

function Posts() {

  const [products,setProducts] = useState([])
  const productRef = (collection(db,'products'))
  const {setPostDetails} = useContext(PostContext)
  const navigate = useNavigate()

  const getPosts = async() => {
    try {
      const post = await getDocs(productRef);
      const allPost = post.docs.map((prdt) =>(
        {...prdt.data(),id:prdt.id}
      ))
      console.log(allPost)
      setProducts(allPost)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(()=>{
    getPosts();
  },[])

  return (
    <div className="postParentDiv">
      <div className="moreView">
        <div className="heading">
          <span>Quick Menu</span>
          <span>View more</span>
        </div>
        <div className="cards">
        {
          products.map((product)=> {
            return <div className="card" onClick={()=> {
              setPostDetails(product)
              navigate('/view')
            }}>

            <div className="favorite">
              <Heart></Heart>
            </div>
            <div className="image">
              <img src={product.url} alt="" />
            </div>
            <div className="content">
              <p className="rate">&#x20B9; {product.price}</p>
              <span className="kilometer">{product.category}</span>
              <p className="name"> {product.name}</p>
            </div>
            <div className="date">
              <span>{product.createdAt}</span>
            </div>
          </div>
          })
        }
        </div>
      </div>
      <div className="recommendations">
        <div className="heading">
          <span>Fresh recommendations</span>
        </div>
        <div className="cards">
          <div className="card">
            <div className="favorite">
              <Heart></Heart>
            </div>
            <div className="image">
              <img src="../../../Images/R15V3.jpg" alt="" />
            </div>
            <div className="content">
              <p className="rate">&#x20B9; 250000</p>
              <span className="kilometer">Two Wheeler</span>
              <p className="name"> YAMAHA R15V3</p>
            </div>
            <div className="date">
              <span>Mon Jul 31 2023</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Posts;
